import ScrollToTop from '../Components/ScrollToTop';
import HeroSection2 from '../Components/HeroSection2/Index';
import InfoSection from '../Components/Infosection/Index';
import { homeObjOne } from '../Components/Infosection/Data';
import Contact from '../Components/Contact/Contact';

const About = () => {
  return (
    <div>
        <ScrollToTop />
        <HeroSection2 />
        <InfoSection {...homeObjOne} />
        <Contact />
    </div>
  )
}

export default About